import { useContext } from 'react'

import LoadingModalContext from 'components/UI/Loading/LoadingModalContext'

const useLoadingModal = () => {
  return useContext(LoadingModalContext)
}

export default useLoadingModal
